import React from 'react';
import './PrivacyPolicy.css'; // Agar aap custom CSS add karna chahein

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container" style={{ padding: '40px 20px', maxWidth: '1000px', margin: '0 auto', lineHeight: '1.6' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '30px', color: '#1a2b4c' }}>Privacy Policy</h1>
      
      <p>Last updated: [Current Date]</p>

      <section style={{ marginBottom: '20px' }}>
        <h2>1. Introduction</h2>
        <p>Welcome to <strong>Lace Gota</strong> ("we," "our," or "us"). We respect your privacy and are committed to protecting your personal data. This privacy policy will inform you as to how we look after your personal data when you visit our website (sgtblace.cloud) and tell you about your privacy rights.</p>
      </section>

      <section style={{ marginBottom: '20px' }}>
        <h2>2. Data We Collect</h2>
        <p>We may collect, use, store and transfer different kinds of personal data about you which we have grouped together as follows:</p>
        <ul>
          <li><strong>Identity Data:</strong> includes first name, last name, username or similar identifier.</li>
          <li><strong>Contact Data:</strong> includes billing address, delivery address, email address and telephone numbers.</li>
          <li><strong>Financial Data:</strong> includes bank account and payment card details (processed securely via our payment gateways).</li>
          <li><strong>Transaction Data:</strong> includes details about payments to and from you and other details of products you have purchased from us.</li>
        </ul>
      </section>

      <section style={{ marginBottom: '20px' }}>
        <h2>3. How We Use Your Data</h2>
        <p>We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:</p>
        <ul>
          <li>Where we need to perform the contract we are about to enter into or have entered into with you (e.g., processing your order).</li>
          <li>To manage our relationship with you, including notifying you about changes to our terms or privacy policy.</li>
          <li>To administer and protect our business and this website.</li>
        </ul>
      </section>

      <section style={{ marginBottom: '20px' }}>
        <h2>4. Data Sharing</h2>
        <p>We may have to share your personal data with third parties such as delivery partners (couriers) and secure payment gateways strictly for the purpose of fulfilling your order.</p>
      </section>

      <section style={{ marginBottom: '20px' }}>
        <h2>5. Contact Us</h2>
        <p>If you have any questions about this privacy policy or our privacy practices, please contact us at:</p>
        <ul>
          <li><strong>Email:</strong> [Your Contact Email]</li>
          <li><strong>Phone:</strong> [Your Phone Number]</li>
        </ul>
      </section>
    </div>
  );
};

export default PrivacyPolicy;